import Text from 'components/Text/Text';
import { useDelay } from 'hooks/useDelay';
import React from 'react';
import breadcrumbs from 'images/breadcrumbs.svg';
import Button from 'components/Button/Button';
import classNames from 'classnames';
import style from './ModalSentSuccessfully.module.scss';

interface IProps {
	onConsentEvent: () => void;
	isVisible: boolean;
	description: string;
	additionalDescription?: string;
	visibleTime?: number;
}

const ModalSentSuccessfully: React.FC<IProps> = ({
	onConsentEvent,
	isVisible,
	description,
	additionalDescription,
	visibleTime,
}) => {
	useDelay(onConsentEvent, isVisible ? visibleTime : undefined);
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });
	const descriptionClasses = classNames(style.description, {
		[style.descriptionWithAdditional]: !!additionalDescription,
	});
	const showOkButton = !visibleTime;

	return (
		<div className={containerClasses} data-test={`ModalSentSuccessfully${isVisible ? 'IsVisible' : ''}`}>
			<div className={style.wrapper}>
				<svg className={style.successIcon}>
					<use xlinkHref={`${breadcrumbs}#success`} />
				</svg>
				<Text
					className={descriptionClasses}
					translationNameSpace="modals"
					translationKey={description}
					size="xxl"
					weight="bold"
					align="center"
				/>
				{additionalDescription && (
					<Text
						className={style.additionalDescription}
						translationNameSpace="modals"
						translationKey={additionalDescription}
						size="m"
						align="center"
					/>
				)}
				{showOkButton && (
					<div className={style.btnWrapper}>
						<Button
							className={style.okBtn}
							theme="primaryBlue"
							onClick={onConsentEvent}
							type="submit"
							data-test="okButton">
							<Text translationNameSpace="modals" translationKey="okButton" asFragment={true} />
						</Button>
					</div>
				)}
			</div>
		</div>
	);
};

export default React.memo(ModalSentSuccessfully);
